import { Close } from "@mui/icons-material";
import {
  AppBar,
  Box,
  Button,
  Dialog,
  IconButton,
  List,
  ListItemButton,
  Toolbar,
  Typography,
  Tooltip as Tp,
  TextField,
  Autocomplete,
  MenuItem
} from "@mui/material";
import { getLabels } from "api/services/labels";
import { getUsers } from "api/services/users";
import Loader from "components/Loader";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { handleApply, resetState, } from "redux/reducers/clientsSlice";
import { ResType } from "types";

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { getFilters } from "views/tasks/Filters/getFilters";
import { selectClient } from "redux/reducers/clientsSlice";
import { handleFieldChange } from "redux/reducers/clientsSlice";
import useClientCategories from "hooks/useClientCategories";

interface IProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}




function AllFiltersDialog({ open, setOpen }: IProps) {
  const dispatch = useDispatch();
  const states = useSelector(selectClient);
  const { data: labels, isLoading: labelsLoading }: ResType = useQuery("labels", getLabels, {
    enabled: open,
  });

  const { data: users, isLoading: userLoading }: ResType = useQuery("users", getUsers, { enabled: open });

  const applyFilters = () => {
    dispatch(handleApply());
    setOpen(false);
  };

  const handleReset = () => {
    dispatch(resetState());
    setOpen(false);
  };

  const filters = getFilters({ users });

  const {
    categories,
    subCategories,
  } = useClientCategories({
    selectedCategoryId:
      states?.selectedFilters
        ?.category?.id,
  });

  interface StatusOption {
    name: string;
    value: string;
  };

  const options =
    [{ name: "ACTIVE", value: "ACTIVE" },
    { name: "INACTIVE", value: "INACTIVE" }]


  return (
    <Dialog
      sx={{ alignItems: "flex-start", maxHeight: 600 }}
      fullWidth
      maxWidth="sm"
      open={open}
      PaperProps={{
        elevation: 0,
        sx: { display: "flex", flexDirection: "column" },
      }}
    >
      <AppBar
        position="static"
        color="transparent"
        sx={{ boxShadow: "none", borderBottom: "1px solid lightgrey" }}
      >
        <Toolbar sx={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="subtitle1">Filters</Typography>
          <IconButton onClick={() => setOpen(false)}>
            <Close color="primary" />
          </IconButton>
        </Toolbar>
      </AppBar>
      {labelsLoading ? (
        <Loader minHeight="400px" />
      ) : (
        <>

          <Box sx={{ overflowY: "auto", mt: 2, pt: 1, px: 2, pb: 4, flex: 1 }}>


            <TextField
              variant="outlined"
              fullWidth
              onChange={(e) => dispatch(handleFieldChange({ key: "monthAdded", value: e.target.value }))}
              value={states.selectedFilters.monthAdded}
              name="monthAdded"
              required
              InputLabelProps={{ shrink: true }}
              size="small"
              label="Month Added"
              type="month"
            />
            <Autocomplete
              id="tags-standard"
              onChange={(_, value) => {

                dispatch(
                  handleFieldChange({
                    key: "category",
                    value: value || null,
                  }),
                );

                dispatch(
                  handleFieldChange({
                    key: "subCategory",
                    value: [],
                  }),
                );
              }}
              value={states.selectedFilters.category || null}
              options={categories || []}
              sx={{ mt: 3 }}
              getOptionLabel={(option: any) => option?.name || ''}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  variant="outlined"
                  size="small"
                  fullWidth
                  label="Client Category"
                />
              )}
            />
            {subCategories?.length > 0 && (
              <Autocomplete
                id="tags-standard"
                multiple
                // onChange={(_, value) => {
                //   setState({
                //     ...state,
                //     subCategory: value,
                //   });
                // }}
                onChange={(_, value) => dispatch(handleFieldChange({ key: "subCategory", value: value || [] }))}
                value={states.selectedFilters.subCategory || []}
                options={subCategories || []}
                sx={{ mt: 3 }}
                getOptionLabel={(option: any) => option?.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    variant="outlined"
                    size="small"
                    fullWidth
                    label="Client Sub Category"
                  />
                )}
              />
            )}
            <Autocomplete
              id="tags-standard"
              multiple
              onChange={(_, value) => dispatch(handleFieldChange({ key: "labels", value: value || [] }))}
              value={states.selectedFilters.labels || []}
              options={labels?.data?.[0] || []}
              sx={{ mt: 3 }}
              getOptionLabel={(option: any) => option?.name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  required
                  variant="outlined"
                  size="small"
                  fullWidth
                  label="Labels"
                />
              )}
            />

            <Autocomplete
              id="tags-standard"
              options={options || []}
              getOptionLabel={(option) => option.name || ""}
              onChange={(_, value) =>
                dispatch(handleFieldChange({ key: "status", value: value || '' }))
              }
              value={states?.appliedFilters?.status}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Status"
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ mt: 3 }}
                />
              )}
              fullWidth
              size="small"
            />
          </Box>
        </>)}
      <AppBar
        position="static"
        color="transparent"
        sx={{ boxShadow: "none", borderTop: "1px solid lightgrey" }}
      >
        <Toolbar sx={{ justifyContent: "flex-end", gap: 2, alignItems: "center" }}>
          <Button onClick={handleReset} variant="outlined" color="secondary">
            Reset
          </Button>
          <Button onClick={applyFilters} variant="contained" color="secondary">
            Apply
          </Button>
        </Toolbar>
      </AppBar>
    </Dialog>
  );
}

export default AllFiltersDialog;